type AppName = 'frontend' | 'backoffice' | 'frontendleedflow' | 'backend' | 'backend-backup-callr' | 'backend-healthcheck';

function metadata(appName: AppName) {
  // @ts-ignore import.meta.env is a vite special keyword. Kept as ts-ignore and not
  // as an expect-error directive: the error only exists when this lib is compiled
  // standalone (commonjs), so expecting it breaks the vite apps' typecheck.
  const env = import.meta?.env ? import.meta.env : process.env;
  let appId;
  switch (appName) {
    case 'frontend':
      appId = env.VITE_FIREBASE_FRONTEND_APP_ID;
      break;
    case 'backoffice':
      appId = env.VITE_FIREBASE_BACKOFFICE_APP_ID;
      break;
    case 'frontendleedflow':
      appId = env.VITE_FIREBASE_FRONTENDLEEDFLOW_APP_ID;
      break;
    default:
      break;
  }
  return {
    apiKey: env.VITE_FIREBASE_API_KEY,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
    databaseURL: env.VITE_FIREBASE_DATABASE_URL,
    databaseId: env.VITE_FIREBASE_DATABASE_ID,
    projectId: env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: appId,
  };
}

export { AppName, metadata };
